// @ts-check
import React, { useCallback } from 'react';
import api from 'utils/api';
import { Page, Row } from 'shared/containers/portal_layout';
import { browserHistory } from 'react-router';
// import styles from './OrganizationSettingsPage.module.scss';
import { useQuery } from 'react-query';
import Select from 'react-select';
import DefaultOption from 'react-select/lib/Option';

/**
 * EntityOption.
 */

/** @type { React.FC<{option: any}> } */
const EntityOption = props => {
  return (
    <DefaultOption {...props}>
      <span>
        {props.option.name}{' '}
        <span style={{ color: '#999'}}>({props.option.type})</span>
      </span>
    </DefaultOption>
  );
}


/**
 * OrganizationSettingsPage.
 */

const path = '/agent_portal/api/organizations';
const queryKey = path;

/** @type { React.FC<{params: any}> } */
export const OrganizationSettingsPage = (props) => {
  const { children, params } = props;
  const { entityId } = params;

  const { isLoading, data } = useQuery(queryKey, () =>
    api.get(path).then((resp) => resp.data)
  );

  const selectedEntity =
    isLoading || !data ? null : findEntityInHierarchies(data, entityId);

  const onSelect = useCallback((entity) => {
    const path = `/a/portal/entity_settings/${entity.id}`;
    browserHistory.push(path);
  }, []);

  return (
    <Page title="Organization Settings">
      <Row>
        <div className="flex items-center p-4 m-4 bg-white border rounded-md shadow">
          <div className="w-1/3 max-w-sm pr-2 text-right">
            <label className="font-semibold">Select Organization/Location:</label>
          </div>
          <div className="w-2/3 max-w-md pl-2">
            <Select
              isLoading={isLoading}
              clearable={false}
              value={entityId}
              options={isLoading ? [] : flattenEntities(data)}
              labelKey="name"
              valueKey="id"
              onChange={onSelect}
              optionComponent={EntityOption}
            />
          </div>
        </div>
      </Row>
      <Row>
        {isLoading || !data
          ? null
          : React.cloneElement(children, { entity: selectedEntity })}
      </Row>
    </Page>
  );
};

/**
 * Given an array of Entities (Organization/Location), do a breadth first search to find
 * the Entity in the hierarchy with a given ID.
 *
 * @param {Array<{id: string, children: Array<any>}>} entities
 * @param {string} entityId
 */
 function findEntityInHierarchies(entities, entityId) {
  let found = entities.find((e) => e.id === entityId);

  if (found) {
    return found;
  }

  entities.forEach((e) => {
    if (e.children && e.children.length > 0) {
      found = findEntityInHierarchies(e.children, entityId);
    }
  });
  return found;
}

function flattenEntities(orgs, collected = []) {
  orgs.forEach((entity) => {
    collected.push(entity);
    if (entity.children && entity.children.length > 0) {
      flattenEntities(entity.children, collected);
    }
  });
  return collected;
}
